var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { GalleryActions } from '../../state/gallery.actions';
import { GalleryState } from '../../state/gallery.state';
import { Subject, Observable } from 'rxjs';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
import { takeUntil, filter, debounceTime, tap, map, distinctUntilChanged } from 'rxjs/operators';
import { groupBy } from 'lodash';
import { FormBuilder } from '@angular/forms';
export class GalleryFiltersStudioComponent {
    constructor(store, changeDetectorRef, formBuilder) {
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.formBuilder = formBuilder;
        this.ngUnsubscribe = new Subject();
        this.groupedOptions = {};
    }
    get queryControl() {
        return this.form.get('query');
    }
    get categoryControl() {
        return this.form.get('category');
    }
    ngOnInit() {
        this.initForm();
        this.initFormListeners();
        this.populateDropdown();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    initForm() {
        const category = this.store.selectSnapshot(GalleryState.getStudioCategoryId);
        const query = this.store.selectSnapshot(GalleryState.getStudioQuery);
        this.form = this.formBuilder.group({
            category: [category],
            query: [query]
        });
    }
    initFormListeners() {
        this.form.valueChanges
            .pipe(tap(() => {
            this.category = this.store.selectSnapshot(GalleryState.getStudioOptions).find(option => option.id === this.categoryControl.value);
            this.changeDetectorRef.markForCheck();
        }), map(value => JSON.stringify(value)), distinctUntilChanged(), map(value => JSON.parse(value)), debounceTime(300), takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.store.dispatch(new GalleryActions.SearchStudio(this.category, this.queryControl.value));
        });
    }
    populateDropdown() {
        // Populate dropdown with organization collections, if available
        const organization = this.store.selectSnapshot(OrganizationsState.getOrganization);
        this.store.dispatch(new GalleryActions.GetStudioOptions(organization ? organization.id : null));
        this.store.select(GalleryState.getStudioOptions)
            .pipe(filter(options => options.length > 0), takeUntil(this.ngUnsubscribe))
            .subscribe(options => {
            this.updateOptions(options);
        });
    }
    updateOptions(options) {
        this.groupedOptions = groupBy(options, (option) => {
            return option.type;
        });
        const category = this.store.selectSnapshot(GalleryState.getStudioCategoryId);
        this.category = options.find(option => option.id === category);
        this.categoryControl.setValue(this.category.id);
        this.changeDetectorRef.markForCheck();
    }
}
__decorate([
    Select(GalleryState.getStudioCategoryId),
    __metadata("design:type", Observable)
], GalleryFiltersStudioComponent.prototype, "categoryId$", void 0);
__decorate([
    Select(GalleryState.getStudioQuery),
    __metadata("design:type", Observable)
], GalleryFiltersStudioComponent.prototype, "query$", void 0);
